module.exports = __webpack_public_path__ + "img/style_3_5.fe9cf705.png";